import { useState } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import DepartmentService from "../../../../../services/Company/DepartmentService";
import DeleteModal from "../../../../common/DeleteModal";
import { Translate } from "../../../../Enums/Tranlate";

const CardItem = ({ item, setItem, index, setAddModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const departmentService = new DepartmentService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.name}</td>
			<td>{item?.breanch?.names[lang] || "-"}</td>
			<td>
				{/* {(isExist("edit_job_title") || isExist("delete_job_title")) && ( */}
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-h" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{/* {isExist("edit_job_title") && ( */}
						<Dropdown.Item
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}>
							<i className="la la-edit"></i> {Translate[lang]?.edit}
						</Dropdown.Item>
						{/* )} */}
						{/* {isExist("delete_job_title") && ( */}
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							<i className="la la-trash"></i> {Translate[lang]?.delete}
						</Dropdown.Item>
						{/* )} */}
					</Dropdown.Menu>
				</Dropdown>
				{/* )} */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={departmentService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
